import { useEffect, useState } from 'react';
import {
  getDefaultInventaireViewMode,
  INVENTAIRE_VIEW_MODE_STORAGE_KEY,
  InventaireViewMode,
  parseInventaireViewMode,
} from '../utils/inventaireViewMode';

export function useInventaireViewMode() {
  const [viewMode, setViewMode] = useState<InventaireViewMode>(() => {
    const saved = parseInventaireViewMode(localStorage.getItem(INVENTAIRE_VIEW_MODE_STORAGE_KEY));
    return saved ?? getDefaultInventaireViewMode();
  });

  useEffect(() => {
    localStorage.setItem(INVENTAIRE_VIEW_MODE_STORAGE_KEY, viewMode);
  }, [viewMode]);

  return [viewMode, setViewMode] as const;
}
